import React from 'react';
import '../css/OpeningOptionStyling.css';
import { ReactComponent as GardenDesignerImage } from '../images/landingPageSvg/gardenDesignerPic.svg';
import { ReactComponent as CommunityGardensImage } from '../images/landingPageSvg/CommunityGardensSVG.svg';
import { ReactComponent as PlantFinderImage } from '../images/landingPageSvg/PlantFinderSVG.svg';
import { ReactComponent as YourGardensImage } from '../images/landingPageSvg/YourGardensSVG.svg';
import '../css/animationStylings/landingPageAnimations/gardenDesignerSvgStyling.css';
import '../css/animationStylings/landingPageAnimations/communityGardensAnimationStyling.css';
import '../css/animationStylings/landingPageAnimations/PlantFinderAnimationStyling.css';
import '../css/animationStylings/landingPageAnimations/yourGardensAnimationStyling.css';

const OpeningOption = ({ gardenType, onSelect, isSelected }) => {

    // Option 1: Use React components for SVGs and fallback to images
    const gardenComponents = {
        "Garden Designer": GardenDesignerImage,
        "Community Gardens": CommunityGardensImage,
        "Plant Finder": PlantFinderImage,
        "Your Gardens": YourGardensImage
    };

    const gardenStyles = {
        "Garden Designer": "./gardenDesignerImage.png",
        "Your Gardens": "./myGardensImage.png",
        "Plant Finder": './plantFinderImage.png',
        "Community Gardens": "./CommunityGardens.png"
    };

    const gardenDescriptions = {
        "Garden Designer": "Create detailed garden layouts with our intuitive grid-based planner. Visualize your space and optimize plant placement for maximum yield.",
        "Your Gardens": "Track multiple garden spaces, monitor plant progress, and manage your harvest schedule all in one convenient dashboard.",
        "Plant Finder": "Discover the perfect plants for your climate, soil, and growing conditions. Our database helps you make informed planting decisions.",
        "Community Gardens": "Connect with fellow gardeners, share tips, and collaborate on community growing projects. Growing is better together!"
    };

    const SvgComponent = gardenComponents[gardenType];
    const imageSource = gardenStyles[gardenType] || "./plant.png";
    const description = gardenDescriptions[gardenType];

    return (
        <div>
            <div
                className={`opening-option-card ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelect(gardenType)}
            >
                <div className={"opening-option-image-container"}>
                    {SvgComponent ? (
                        <SvgComponent className="opening-option-picture"/>
                    ) : (
                        <img className="opening-option-picture" src={imageSource} alt="Option Image"/>
                    )}
                </div>
                <h3 className="opening-option-card-title">{gardenType}</h3>
                <p className={"opening-option-card-description"}>{description}</p>
            </div>
        </div>
    );
};

export default OpeningOption;